import { useRive, Layout, Fit } from '@rive-app/react-canvas';

import { generateClassName } from '@klv/shared/utils/functions';

import { useRiveUrl, useRiveTextRuns } from './hooks';
import { riveAssetLoader, calculateRiveStyle } from './utils';
import * as styles from './styles/rive.module.css';

import type { IRiveAtomProps } from './types';



export const Rive = ({
  ariaLabelText,
  aspectRatio = '1',
  className = '',
  flexibleLayout,
  height,
  riveFile,
  riveText,
  ...props
}: IRiveAtomProps) => { 

  const riveUrl = useRiveUrl(riveFile);
  
  const { rive, RiveComponent } = useRive({ 
    src: riveUrl,
    autoplay: true,
    layout:new Layout({ 
      fit: flexibleLayout ? Fit.Layout : Fit.Contain,
    }),
    assetLoader: riveAssetLoader(),
  });
  
  useRiveTextRuns(rive, riveText);

  const riveStyle = calculateRiveStyle(flexibleLayout, aspectRatio, height);

  return (
    <div className={generateClassName([className, styles.rive])} {...props}>
      <RiveComponent data-chromatic="ignore" style={riveStyle} aria-label={ariaLabelText} role='img' />
    </div>
  );
};
